import { cn } from "@/lib/utils";
import { ErrorHeader } from "./ErrorHeader";
import { ErrorLocation } from "./ErrorLocation";

interface ErrorContentProps {
  message?: string;
  filename?: string;
  lineno?: number;
  colno?: number;
  stack?: string;
  onClose?: () => void;
  onFixWithAI?: (e: React.MouseEvent) => void;
  zoomScale?: string;
  heightFull?: boolean;
  alwaysExpanded?: boolean;
}

export function ErrorContent({
  message = "An error occurred",
  filename = "unknown",
  lineno = 1,
  colno = 1,
  stack,
  onClose,
  onFixWithAI,
  zoomScale = "1",
}: ErrorContentProps) {
  return (
    <div
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={cn(
        "w-full bg-secondary-0 rounded-lg overflow-hidden pointer-events-auto select-text relative cursor-default shadow-lg flex flex-col",
      )}
    >
      <div className="relative">
        <ErrorHeader
          message={message}
          isExpanded={true}
          onClose={onClose}
          zoomScale={zoomScale}
        />
      </div>
      <div className="overflow-hidden flex flex-col">
        <ErrorLocation
          filename={filename}
          lineno={lineno}
          colno={colno}
          zoomScale={zoomScale}
        />

        {stack && (
          <div
            className="font-mono text-secondary-n-50 whitespace-pre-wrap wrap-break-word border-t border-secondary-300 text-2xs p-3 overflow-y-auto overflow-x-hidden"
            style={{
              fontSize: `calc(10px * ${zoomScale})`,
              lineHeight: 1.5,
              maxHeight: `calc(200px * ${zoomScale})`,
            }}
          >
            {stack}
          </div>
        )}
      </div>
      {onFixWithAI && (
        <div className="border-t border-secondary-300 bg-secondary-50 p-3 shrink-0">
          <button
            data-testid="fix-with-ai-button"
            className="w-full bg-[#6448EF] hover:bg-[#5E44E4] text-white font-medium transition-colors duration-200 flex items-center justify-center pointer-events-auto rounded-md"
            style={{
              padding: `calc(8px * ${zoomScale}) calc(16px * ${zoomScale})`,
              fontSize: `calc(13px * ${zoomScale})`,
            }}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={onFixWithAI}
          >
            Fix with AI
          </button>
        </div>
      )}
    </div>
  );
}

export default ErrorContent;
